"use client";

import { Modal } from "@kyan/ui";

import { ContentWrapper } from "#/app/(desktop)/layouts/TradePanel/components/ContentWrapper/ContentWrapper";
import { useShowTradePanel } from "#/store/app/tradePanel/showTradePanel";

export const TradePanelModal: React.FC = () => {
  const { showTradePanel, setShowTradePanel } = useShowTradePanel();

  return (
    <Modal
      header="Trade"
      shouldScroll={false}
      open={showTradePanel}
      onOpenChange={setShowTradePanel}
    >
      <ContentWrapper />
    </Modal>
  );
};
